import { Event } from "interfaces/content";

import React from "react";
import styled from "styled-components";
import styles from "styles/styles";
import { ics } from "calendar-link";

import useTranslate from "hooks/common/useTranslate/useTranslate";
import useLocale from "hooks/common/useLocale/useLocale";
import { hasPassed } from "utils/dateAndTime";

const StyledAddToCalendarLink = styled.a`
    font-style: italic;
    font-size: ${styles.fontSize.smaller};
    color: ${styles.colors.grey7};
`;

interface Props {
    event: Event;
}

export const isAddableToCalendar = (event: Event) =>
    event.endDate ? !hasPassed(event.endDate) : !hasPassed(event.date, 30);

export default ({ event }: Props) => {
    const translate = useTranslate();
    const locale = useLocale();

    return (
        <StyledAddToCalendarLink
            onClick={(e) => e.stopPropagation()}
            href={ics({
                title: event.description[locale] ?? "Fingrid Webinar",
                description: event.weblink,
                start: event.date,
                end: event.endDate,
                duration: !event.endDate ? [0.5, "hour"] : undefined,
            })}
            target="_blank"
        >
            {translate("common.addToCalendar")}
        </StyledAddToCalendarLink>
    );
};
